export default function ErrorBox({ title, icon, children }) {
    return <div className="rounded-md bg-red-50 p-4">
        <div className="flex">
            {icon && <div className="flex-shrink-0">
                {icon}
            </div>}
            <div className="ml-3">
                {title && <h3 className="text-sm font-medium text-red-800">{title}</h3>}
                <div className="mt-2 text-sm text-red-700 inline">
                    {children}
                </div>
            </div>
        </div>
    </div>
}